const Icon = (props) => {
  return (
    <span
      data-pr-tooltip={props.tooltip}
      className={`${
        props.className ? props.className : ''
      } material-symbols-rounded ${
        props.defaultColor ? props.defaultColor : 'icon'
      }`}
      onClick={props.onClick}
      style={props.style}
    >
      {props.icon}
    </span>
  );
};

export default Icon;
